import axios from 'axios'

export default {
	get: (param) => {
		axios({
			url: param.url,
			method: param.method
		})
		.then((res) => {
			param.callback(res)
		})
	},
	post: (param) => {
		axios({
			url: param.url,
			method: param.method,
			data: param.data,
			headers: {
				'Content-Type': 'appliction/json'
			}
		})
		.then((res) => {
			param.callback(res)
		})
	},
	formpost: (param) => {
		axios({
			url: param.url,
			method: param.method,
			data: param.data,
			headers: {
				'Content-Type': 'application/x-www-form-urlencoded'
			}
		})
		.then((res) => {
			param.callback(res)
		})
	}
}



// WEBPACK FOOTER //
// ./src/utils/axios.js